const QuestionCategory = () =>
  import(
    /* webpackChunkName: "base-info-questionnaire-question-category" */ '@/pages/base-info/questionnaire/question-category/index.vue'
  )
const CreateQuestionCategory = () =>
  import(
    /* webpackChunkName: "base-info-questionnaire-question-category" */ '@/pages/base-info/questionnaire/question-category/create.vue'
  )
const EditQuestionCategory = () =>
  import(
    /* webpackChunkName: "base-info-questionnaire-question-category" */ '@/pages/base-info/questionnaire/question-category/edit.vue'
  )

export default {
  path: 'question-category',
  meta: {
    label: 'questionCategory',
    auth: 'questionCategory'
  },
  component: {
    name: 'QuestionCategory',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoQuestionnaireQuestionCategory',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: QuestionCategory
    },
    {
      name: 'BaseInfoCreateQuestionnaireQuestionCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateQuestionCategory
    },
    {
      name: 'BaseInfoEditQuestionnaireQuestionCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditQuestionCategory,
      props: true
    }
  ]
}
